export const enrollmentConfirmation = {
  title: "Request Sent Successfully!",
  subtitle: "We have received your pre-enrollment request. We will contact you soon to continue with the admission process.",
  
  nextStepsTitle: "Next Steps",
  steps: {
    step1: {
      title: "Review of your application",
      description: "Our team will review the information you have provided. We will contact you within 48 business hours."
    },
    step2: {
      title: "Personalized guided tour",
      description: "We will coordinate a visit to our facilities where you can learn about our methodology, educational team and resolve all your questions."
    },
    step3: {
      title: "Enrollment process",
      description: "If both parties agree and there are available places, we will proceed with the formalization of the enrollment."
    }
  },
  
  contactTitle: "Need to Contact Us?",
  contact: {
    phone: "Phone",
    email: "Email",
    address: "Address",
    hours: "Hours",
    hoursValue: "Monday to Friday, 8:45 AM - 2:00 PM"
  },
  
  scheduleVisit: "Schedule Visit",
  backToHome: "Back to Home",
  
  note: "If you do not receive a response within 48 hours, please check your spam folder or contact us directly."
};